// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__fWdmh","name":"ConsentHeader_name__3ieoE","birthday":"ConsentHeader_birthday__pu55u","skeleton":"ConsentHeader_skeleton__RmjOj"};